import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, isTokenExpired, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import apps from './routes/apps'
import landing from './routes/landing'
import products from './routes/products'
import home from './routes/home'
import adminpanel from './routes/adminpanel'
import savedquotes from './routes/savedquotes'
import dashboard from './routes/dashboard'
import uiElements from './routes/ui-elements/index'
import pages from './routes/pages'
import chartsMaps from './routes/charts-maps'
import formsTable from './routes/forms-tables'
import others from './routes/others'
import terms from './routes/terms'
import privacy from './routes/privacy'
import about from './routes/aboutus'
import contact from './routes/contact'
import affiliate from './routes/affiliate'
import payments from './routes/payments'
import cancellations from './routes/cancellations'
import claims from './routes/claims'
import summmary from './routes/summary'
import information from './routes/information'
import offers from './routes/offers'
import sales from './routes/sales'
import profile from './routes/profile'
import logout from './routes/logout'
import customerDetails from './routes/customerDetails'
import store from '@/store'
import { performLogoutWithoutRedirect } from '@/auth/logout'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'auth-login' } },
    ...apps,
    ...home,
    ...profile,
    ...landing,
    ...products,
    ...adminpanel,
    ...savedquotes,
    ...dashboard,
    ...pages,
    ...chartsMaps,
    ...formsTable,
    ...uiElements,
    ...others,
    ...terms,
    ...privacy,
    ...about,
    ...contact,
    ...affiliate,
    ...payments,
    ...cancellations,
    ...claims,
    ...offers,
    ...sales,
    ...summmary,
    ...information,
    ...logout,
    ...customerDetails,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, from, next) => {
  // router/index.js – toast only when we actually log out a user
  const isLoggedIn = isUserLoggedIn();

  // Allow navigation to login if already logged out
  if (to.name === 'auth-login' && !isLoggedIn) {
    return next()
  }
  
  // Check if token expired
  if (isTokenExpired(to)) {
    performLogoutWithoutRedirect(store)
    return
  }

  // Admin route protection
  if (to.meta.requiresAdmin) {
    const role = store.state.app?.userData?.role ?? 'client'
    if (role !== 'admin') return next({ name: 'misc-not-authorized' })
  }

  if (!canNavigate(to)) {
    if (!isLoggedIn && to.name !== 'auth-login') {
      return next({ name: 'auth-login' });
    }
    if (isLoggedIn && to.name !== 'misc-not-authorized') {
      return next({ name: 'misc-not-authorized' });
    }
    return next();
  }

  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData();
    const homeRoute = getHomeRouteForLoggedInUser(userData ? userData.role : null);
    if (to.name !== homeRoute.name && to.path !== homeRoute.path) {
      return next(homeRoute);
    }
    return next();
  }

  return next();
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  if (localStorage.getItem("checkedProducts") !== null) {
    localStorage.removeItem("checkedProducts");
  }
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.onError(err => {
  if (err.name !== 'NavigationDuplicated') {
    console.error('Router error:', err);
  }
});

export default router
